import { render } from "./PagamentoPixCartao.vue?vue&type=template&id=70d99432"
import script from "./PagamentoPixCartao.vue?vue&type=script&lang=js"
export * from "./PagamentoPixCartao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__